import { AppContext } from "global/AppContext"
import { useContext } from "react"

export const useAppContext = () => useContext(AppContext);